import React from "react"
import { useTranslation } from "react-i18next"

import { CopyToClipboard } from "components/Elements"
import { useOperator } from "hooks"
import { BICYCODE_CONTACT_EMAIL, BICYCODE_ID } from "operators/bicycode/config"

type NeedHelpBlockProps = {
	className?: string
}

export const NeedHelpBlock: React.FC<NeedHelpBlockProps> = ({ className }) => {
	const { t } = useTranslation()
	const { currentOperator } = useOperator()

	return (
		<div className={`text-center mt-12 ${className}`}>
			<h2 className="font-bold text-primary font-heading text-l">
				{t("add_bike_page.need_help", {
					ns: "bike",
				})}
			</h2>
			<p className="md:flex md:items-center md:justify-center">
				{t("add_bike_page.need_help_description", {
					ns: "bike",
				})}
				{currentOperator.id === BICYCODE_ID && (
					<CopyToClipboard
						text={BICYCODE_CONTACT_EMAIL}
						className="font-bold pl-1 text-primary"
					/>
				)}
			</p>
		</div>
	)
}
